{
  "generatedAt": "2026-11-03T13:39:35.622Z",
  "generator": "packages/game-data/scripts/fetch-game-data.mjs",
  "gameDataNote": "Community datasets, not official Frontier data. Verify critical values in-game. See SOURCES.md.",
  "sources": {
    "fdevShipyard": "https://raw.githubusercontent.com/EDCD/FDevIDs/master/shipyard.csv",
    "fdevOutfitting": "https://raw.githubusercontent.com/EDCD/FDevIDs/master/outfitting.csv",
    "fdevEngineers": "https://raw.githubusercontent.com/EDCD/FDevIDs/master/engineers.csv",
    "fdevCommodity": "https://raw.githubusercontent.com/EDCD/FDevIDs/master/commodity.csv",
    "fdevCombatRank": "https://raw.githubusercontent.com/EDCD/FDevIDs/master/combatrank.csv",
    "fdevTradeRank": "https://raw.githubusercontent.com/EDCD/FDevIDs/master/TradeRank.csv",
    "fdevExplorationRank": "https://raw.githubusercontent.com/EDCD/FDevIDs/master/ExplorationRank.csv",
    "fdevFederationRank": "https://raw.githubusercontent.com/EDCD/FDevIDs/master/FederationRank.csv",
    "fdevEmpireRank": "https://raw.githubusercontent.com/EDCD/FDevIDs/master/EmpireRank.csv",
    "fdevCqcRank": "https://raw.githubusercontent.com/EDCD/FDevIDs/master/CQCRank.csv",
    "edengineerBlueprints": "https://raw.githubusercontent.com/msarilar/EDEngineer/master/EDEngineer/Resources/Data/blueprints.json",
    "edengineerEntryData": "https://raw.githubusercontent.com/msarilar/EDEngineer/master/EDEngineer/Resources/Data/entryData.json",
    "coriolisShipList": "https://api.github.com/repos/EDCD/coriolis-data/contents/ships",
    "coriolisShip": "https://raw.githubusercontent.com/EDCD/coriolis-data/master/ships/{file}",
    "coriolisModuleTree": "https://api.github.com/repos/EDCD/coriolis-data/git/trees/master?recursive=1",
    "coriolisModule": "https://raw.githubusercontent.com/EDCD/coriolis-data/master/{path}",
    "coriolisBlueprints": "https://raw.githubusercontent.com/EDCD/coriolis-data/master/modifications/blueprints.json",
    "coriolisModules": "https://raw.githubusercontent.com/EDCD/coriolis-data/master/modifications/modules.json",
    "coriolisSpecials": "https://raw.githubusercontent.com/EDCD/coriolis-data/master/modifications/specials.json",
    "edsy": "https://edsy.org/eddb.js (pinned source and SHA-256 in third-party/edsy/source.json)"
  },
  "counts": {
    "materials": {
      "raw": 28,
      "manufactured": 64,
      "encoded": 47
    },
    "commodities": 270,
    "modules": 1272,
    "ships": 47,
    "engineers": 38,
    "blueprints": 160,
    "blueprintGrades": 786,
    "experimentalEffects": 91
  },
  "integrity": {
    "unmappedShipFdSymbols": [],
    "unresolvedBlueprintIngredients": [],
    "ingredientAliases": {
      "Abnormal Compact Emissions Data": "Abnormal Compact Emission Data",
      "Adaptive Encyptors Capture": "Adaptive Encryptors Capture"
    },
    "coriolisOnlyBlueprints": [],
    "coriolisOnlyGroupsSkipped": [
      "MC_Overcharged (duplicate of Weapon_Overcharged)",
      "CargoRack_IncreasedCapacity (no recipe data)"
    ],
    "blueprintEngineersNotInEngineerDataset": [],
    "unverifiedGrades": [],
    "heuristicIngredientMatches": [
      "Electronic Countermeasure / Reinforced / G1 -> Misc_Reinforced",
      "Electronic Countermeasure / Reinforced / G2 -> Misc_Reinforced",
      "Electronic Countermeasure / Reinforced / G3 -> Misc_Reinforced",
      "Electronic Countermeasure / Reinforced / G4 -> Misc_Reinforced",
      "Electronic Countermeasure / Reinforced / G5 -> Misc_Reinforced",
      "Electronic Countermeasure / Shielded / G1 -> Misc_Shielded",
      "Electronic Countermeasure / Shielded / G2 -> Misc_Shielded",
      "Electronic Countermeasure / Shielded / G3 -> Misc_Shielded",
      "Electronic Countermeasure / Shielded / G4 -> Misc_Shielded",
      "Electronic Countermeasure / Shielded / G5 -> Misc_Shielded",
      "Heat Sink Launcher / Reinforced / G1 -> Misc_Reinforced",
      "Heat Sink Launcher / Reinforced / G2 -> Misc_Reinforced",
      "Heat Sink Launcher / Reinforced / G3 -> Misc_Reinforced",
      "Heat Sink Launcher / Reinforced / G4 -> Misc_Reinforced",
      "Heat Sink Launcher / Reinforced / G5 -> Misc_Reinforced",
      "Heat Sink Launcher / Shielded / G1 -> Misc_Shielded",
      "Heat Sink Launcher / Shielded / G2 -> Misc_Shielded",
      "Heat Sink Launcher / Shielded / G3 -> Misc_Shielded",
      "Heat Sink Launcher / Shielded / G4 -> Misc_Shielded",
      "Heat Sink Launcher / Shielded / G5 -> Misc_Shielded",
      "Kill Warrant Scanner / Fast Scanner / G1 -> Sensor_FastScan",
      "Kill Warrant Scanner / Fast Scanner / G2 -> Sensor_FastScan",
      "Kill Warrant Scanner / Fast Scanner / G3 -> Sensor_FastScan",
      "Kill Warrant Scanner / Fast Scanner / G4 -> Sensor_FastScan",
      "Kill Warrant Scanner / Fast Scanner / G5 -> Sensor_FastScan",
      "Kill Warrant Scanner / Reinforced / G1 -> Misc_Reinforced",
      "Kill Warrant Scanner / Reinforced / G2 -> Misc_Reinforced",
      "Kill Warrant Scanner / Reinforced / G3 -> Misc_Reinforced",
      "Kill Warrant Scanner / Reinforced / G4 -> Misc_Reinforced",
      "Kill Warrant Scanner / Reinforced / G5 -> Misc_Reinforced",
      "Kill Warrant Scanner / Shielded / G1 -> Misc_Shielded",
      "Kill Warrant Scanner / Shielded / G2 -> Misc_Shielded",
      "Kill Warrant Scanner / Shielded / G3 -> Misc_Shielded",
      "Kill Warrant Scanner / Shielded / G4 -> Misc_Shielded",
      "Kill Warrant Scanner / Shielded / G5 -> Misc_Shielded",
      "Kill Warrant Scanner / Wide Angle Scanner / G1 -> Scanner_WideAngle",
      "Kill Warrant Scanner / Wide Angle Scanner / G2 -> Scanner_WideAngle",
      "Kill Warrant Scanner / Wide Angle Scanner / G3 -> Scanner_WideAngle",
      "Kill Warrant Scanner / Wide Angle Scanner / G4 -> Scanner_WideAngle",
      "Kill Warrant Scanner / Wide Angle Scanner / G5 -> Scanner_WideAngle",
      "Life Support / Shielded / G5 -> LifeSupport_Shielded",
      "Manifest Scanner / Long Range Scanner / G1 -> Scanner_LongRange",
      "Manifest Scanner / Long Range Scanner / G2 -> Scanner_LongRange",
      "Manifest Scanner / Long Range Scanner / G3 -> Scanner_LongRange",
      "Manifest Scanner / Long Range Scanner / G4 -> Scanner_LongRange",
      "Manifest Scanner / Long Range Scanner / G5 -> Scanner_LongRange",
      "Manifest Scanner / Reinforced / G1 -> Misc_Reinforced",
      "Manifest Scanner / Reinforced / G2 -> Misc_Reinforced",
      "Manifest Scanner / Reinforced / G3 -> Misc_Reinforced",
      "Manifest Scanner / Reinforced / G4 -> Misc_Reinforced",
      "Manifest Scanner / Reinforced / G5 -> Misc_Reinforced",
      "Manifest Scanner / Shielded / G1 -> Misc_Shielded",
      "Manifest Scanner / Shielded / G2 -> Misc_Shielded",
      "Manifest Scanner / Shielded / G3 -> Misc_Shielded",
      "Manifest Scanner / Shielded / G4 -> Misc_Shielded",
      "Manifest Scanner / Shielded / G5 -> Misc_Shielded",
      "Point Defence / Reinforced / G1 -> Misc_Reinforced",
      "Point Defence / Reinforced / G2 -> Misc_Reinforced",
      "Point Defence / Reinforced / G3 -> Misc_Reinforced",
      "Point Defence / Reinforced / G4 -> Misc_Reinforced",
      "Point Defence / Reinforced / G5 -> Misc_Reinforced",
      "Point Defence / Shielded / G1 -> Misc_Shielded",
      "Point Defence / Shielded / G2 -> Misc_Shielded",
      "Point Defence / Shielded / G3 -> Misc_Shielded",
      "Point Defence / Shielded / G4 -> Misc_Shielded",
      "Point Defence / Shielded / G5 -> Misc_Shielded",
      "Power Distributor / Shielded / G1 -> PowerDistributor_Shielded",
      "Power Distributor / Shielded / G2 -> PowerDistributor_Shielded",
      "Power Distributor / Shielded / G3 -> PowerDistributor_Shielded",
      "Power Distributor / Shielded / G4 -> PowerDistributor_Shielded",
      "Power Distributor / Shielded / G5 -> PowerDistributor_Shielded",
      "Power Distributor / Weapon Focused / G1 -> PowerDistributor_PriorityWeapons",
      "Power Distributor / Weapon Focused / G2 -> PowerDistributor_PriorityWeapons",
      "Power Distributor / Weapon Focused / G3 -> PowerDistributor_PriorityWeapons",
      "Power Distributor / Weapon Focused / G4 -> PowerDistributor_PriorityWeapons",
      "Power Distributor / Weapon Focused / G5 -> PowerDistributor_PriorityWeapons",
      "Shield Cell Bank / Rapid Charge / G4 -> ShieldCellBank_Rapid",
      "Shield Cell Bank / Specialised / G4 -> ShieldCellBank_Specialised",
      "Surface Scanner / Expanded Probe Scanning Radius / G1 -> Sensor_Expanded",
      "Surface Scanner / Expanded Probe Scanning Radius / G2 -> Sensor_Expanded",
      "Surface Scanner / Expanded Probe Scanning Radius / G3 -> Sensor_Expanded",
      "Surface Scanner / Expanded Probe Scanning Radius / G4 -> Sensor_Expanded",
      "Surface Scanner / Expanded Probe Scanning Radius / G5 -> Sensor_Expanded",
      "Wake Scanner / Fast Scanner / G1 -> Sensor_FastScan",
      "Wake Scanner / Fast Scanner / G2 -> Sensor_FastScan",
      "Wake Scanner / Fast Scanner / G3 -> Sensor_FastScan",
      "Wake Scanner / Fast Scanner / G4 -> Sensor_FastScan",
      "Wake Scanner / Fast Scanner / G5 -> Sensor_FastScan",
      "Wake Scanner / Long Range Scanner / G1 -> Scanner_LongRange",
      "Wake Scanner / Long Range Scanner / G2 -> Scanner_LongRange",
      "Wake Scanner / Long Range Scanner / G3 -> Scanner_LongRange",
      "Wake Scanner / Long Range Scanner / G4 -> Scanner_LongRange",
      "Wake Scanner / Long Range Scanner / G5 -> Scanner_LongRange",
      "Wake Scanner / Reinforced / G1 -> Misc_Reinforced",
      "Wake Scanner / Reinforced / G2 -> Misc_Reinforced",
      "Wake Scanner / Reinforced / G3 -> Misc_Reinforced",
      "Wake Scanner / Reinforced / G4 -> Misc_Reinforced",
      "Wake Scanner / Reinforced / G5 -> Misc_Reinforced",
      "Wake Scanner / Shielded / G1 -> Misc_Shielded",
      "Wake Scanner / Shielded / G2 -> Misc_Shielded",
      "Wake Scanner / Shielded / G3 -> Misc_Shielded",
      "Wake Scanner / Shielded / G4 -> Misc_Shielded",
      "Wake Scanner / Shielded / G5 -> Misc_Shielded",
      "Wake Scanner / Wide Angle Scanner / G1 -> Scanner_WideAngle",
      "Wake Scanner / Wide Angle Scanner / G2 -> Scanner_WideAngle",
      "Wake Scanner / Wide Angle Scanner / G3 -> Scanner_WideAngle",
      "Wake Scanner / Wide Angle Scanner / G4 -> Scanner_WideAngle",
      "Wake Scanner / Wide Angle Scanner / G5 -> Scanner_WideAngle"
    ]
  },
  "files": [
    {
      "file": "materials.json",
      "bytes": 42737,
      "sha256": "0d6562fcc3aaf9f02fe2250cc6dde3b868070b112ddd5c10e417fb67d1e5158b"
    },
    {
      "file": "commodities.json",
      "bytes": 21489,
      "sha256": "3ee418d407f87a3562bcad7168e924ea66273ab1906ef78ee2683d878b0a2523"
    },
    {
      "file": "modules.json",
      "bytes": 677681,
      "sha256": "9988a6a25529d53ee3b94703befd59bdb91da0d023db43cf89988db77cd23259"
    },
    {
      "file": "ships.json",
      "bytes": 536069,
      "sha256": "f7f487416e72dc6067b2a294aa8d2d5ae6af0ecd36312327718089b0ee2ac469"
    },
    {
      "file": "engineers.json",
      "bytes": 6083,
      "sha256": "0ca094610902118e718f6cfe163781cfdec713f43c60102af5482986d2b6c159"
    },
    {
      "file": "ranks.json",
      "bytes": 5671,
      "sha256": "5437755571f8f4b745cede8ab9af94d3098a43588a7be5b8b92dbf7affa3a32e"
    },
    {
      "file": "blueprints.json",
      "bytes": 1124260,
      "sha256": "847b8b1e9110e1e08a007350274901af72312cfa6d40b06717983c31f1c163cc"
    },
    {
      "file": "experimental-effects.json",
      "bytes": 61959,
      "sha256": "8250fbab7f80f6da6d1ac4b480ede5b8ef3242e3f425f06d9b295efa05256260"
    },
    {
      "file": "edsy-outfitting.json",
      "bytes": 865045,
      "sha256": "509b1111fb77f562dd41a2a2adbaf5072bc983cac723f7c437128b2d56e47901"
    }
  ]
}
